import { Navigate, Route, Routes } from 'react-router-dom';
import { LoginPage } from '../features/auth/LoginPage';
import { RequireAuth } from '../features/auth/RequireAuth';
import { OperatorShell } from './OperatorShell';
import { DashboardPage } from '../features/dashboard/DashboardPage';
import { TenantsPage } from '../features/tenants/TenantsPage';
import { CategoriesPage } from '../features/categories/CategoriesPage';
import { ProductsPage } from '../features/products/ProductsPage';
import { SyncPage } from '../features/products/SyncPage';

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <OperatorShell />
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="tenants" element={<TenantsPage />} />
        <Route path="categories" element={<CategoriesPage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="sync" element={<SyncPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
